import React from "react";
import { Box, Button, VStack, Text } from "@chakra-ui/react";

const promptMap = {
  data_analyst: [
    "What insights can you find in this sales dataset?",
    "How does my product perform across retailers?",
    "Can you identify any distribution gaps?",
    "What’s our ACV trend across key accounts?",
    "What velocity insights can we derive from this data?"
  ],
  cpg_cofounder: [
    "Write a tagline and romance copy for a new adaptogenic soda.",
    "What retail strategy would you recommend for a new protein bar?",
    "How should I position my brand for Whole Foods?",
  ],
  category_manager: [
    "How should I categorize this new snack SKU in syndicated data?",
    "Can you analyze category trends for (insert category here)?",
    "What’s the whitespace in the functional hydration category?",
  ],
  retail_buyer: [
    "Does this brand deserve shelf space?",
    "What performance metrics stand out in this report?",
    "Would you approve this product for a 3-month test in your region?",
  ],
  trade_promo_analyst: [
    "What promotions drove the biggest lift in Q2?",
    "Was our TPR effective in Whole Foods Northeast?",
    "Recommend a promo calendar for this brand."
  ],
  brand_manager: [
    "How should I position my brand in functional beverages?",
    "Can you review this product concept and give feedback?",
    "Write 3 brand pillars for a collagen cold brew.",
  ],
  commercial_strategy_director: [
    "What should be our 6-month growth roadmap?",
    "Evaluate risks and opportunities in launching nationally.",
    "What pricing should we target across channels?"
  ],
  distributor: [
    "Can you help evaluate this brand’s case movement?",
    "Would this product succeed in UNFI?",
    "What questions should I ask the brand founder?"
  ],
  product_formulator: [
    "Suggest functional ingredient combinations for stress relief or focus.",
    "What clean label sweeteners and flavors would appeal to today's consumers?",
    "How can I improve texture and mouthfeel in a powdered supplement?",
    "Which natural preservatives can extend shelf life without additives?",
    "What ingredient swaps can reduce cost but maintain function and taste?"
  ],
  dtc_strategist: [
    "Should I launch first on Shopify, Amazon or TikTok Shop for fastest traction?",
    "What CAC and LTV benchmarks should I use for a beverage brand selling DTC?",
    "Suggest optimal pack sizes, bundles, or subscription offers for my online store.",
    "How do I compare gross margin between retail and DTC given my shipping costs?",
    "What retention tactics (email flows, loyalty programs) drive repeat DTC orders?"
  ]

};

const PromptSuggestions = ({ agentId, onPromptSelect }) => {
  const prompts = promptMap[agentId] || [];

  return prompts.length ? (
    <Box mt={2}>
      <Text fontWeight="medium" mb={2}>  Sample Prompts</Text>
      <VStack align="start" spacing={2}>
        {prompts.map((p, idx) => (
          <Button
            key={idx}
            size="sm"
            variant="ghost"
            colorScheme="gray"
            onClick={() => onPromptSelect(p)}
          >
            {p}
          </Button>
        ))}
      </VStack>
    </Box>
  ) : null;
};

export default PromptSuggestions;
